import styled from 'styled-components';

// ✅ Usar sistema de temas - siguiendo patrón MainButton
export const SelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l};
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

// Flex row con los dos grupos en extremos opuestos:
// Izquierda: dropdown + pill | Derecha: cantidad + botón
export const SelectorRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing.m};
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    align-items: stretch;
    gap: ${({ theme }) => theme.spacing.s};
  }
`;

// Grupo izquierdo: dropdown + pill pegados
export const PartidaWithPill = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing.s};
  flex-wrap: wrap;
`;

// Grupo derecho: cantidad + botón pegados
export const AmountGroup = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const SelectorColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AddButton = styled.div`
  display: flex;
  align-items: end;
  height: 100%;
  padding-bottom: 2px; // Alineación visual con inputs
`;

export const CategoryPill = styled.div<{ color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background-color: ${({ color }) => `${color}20`};
  color: ${({ color }) => color};
  border: 1px solid ${({ color }) => `${color}40`};
  margin-bottom: ${({ theme }) => theme.spacing.xxxs};
`;

export const ErrorText = styled.div`
  margin-top: ${({ theme }) => theme.spacing.s};
  color: ${({ theme }) => theme.colors.red};
`;
